(function () {
  function hardReloadCartPage() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('cart_cb', String(Date.now()));
      window.location.replace(u.toString());
    } catch (e) {
      window.location.reload();
    }
  }

  function cartHasGiftLine(cart, handle) {
    if (!cart || !Array.isArray(cart.items) || !handle) return false;
    var h = String(handle).toLowerCase().trim();
    return cart.items.some(function (item) {
      return String(item.handle || '').toLowerCase() === h;
    });
  }

  /**
   * Sum line totals for all items except the gift product (Shopify cents).
   */
  function merchandiseSubtotalExcludingGiftCents(cart, giftHandle) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var gh = String(giftHandle || '').toLowerCase().trim();
    var sum = 0;
    cart.items.forEach(function (item) {
      if (String(item.handle || '').toLowerCase() === gh) return;
      var line = item.final_line_price != null ? item.final_line_price : item.line_price;
      if (typeof line === 'number') sum += line;
    });
    return sum;
  }

  function getCartJsUrl() {
    var cartBase = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart)
      ? theme.routes.cart
      : '/cart';
    return cartBase.indexOf('.js') !== -1
      ? cartBase
      : cartBase.replace(/\/$/, '') + '.js';
  }

  async function fetchCartJson(cartJsUrl) {
    var res = await fetch(cartJsUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!res.ok) return null;
    return res.json();
  }

  async function pollCartUntil(cartJsUrl, predicate, maxMs, interval) {
    var start = Date.now();
    while (Date.now() - start < maxMs) {
      await new Promise(function (r) { setTimeout(r, interval); });
      try {
        var cart = await fetchCartJson(cartJsUrl);
        if (!cart) break;
        if (predicate(cart)) return;
      } catch (e) {
        break;
      }
    }
  }

  /**
   * After cart AJAX: apps may add the gift above $X or remove it below $X asynchronously.
   * Poll /cart.js until state matches, then full page reload.
   */
  async function waitForGiftThenHardReload(cartSnapshot) {
    var settings = (typeof theme !== 'undefined' && theme.settings) ? theme.settings : {};
    if (settings.cartWaitForGiftBeforeReload === false) {
      hardReloadCartPage();
      return;
    }

    var handle = String(settings.cartGiftProductHandle || 'fg-egiftcard').trim();
    if (!handle) {
      hardReloadCartPage();
      return;
    }

    var maxMs = Number(settings.cartGiftWaitMaxMs);
    if (!Number.isFinite(maxMs) || maxMs < 0) maxMs = 5000;
    var interval = Number(settings.cartGiftWaitIntervalMs);
    if (!Number.isFinite(interval)) interval = 300;
    interval = Math.min(800, Math.max(150, interval));

    var threshold = Number(settings.cartGiftThresholdCents);
    if (!Number.isFinite(threshold) || threshold <= 0) threshold = 20000;

    if (!cartSnapshot || typeof cartSnapshot.total_price !== 'number') {
      hardReloadCartPage();
      return;
    }

    var merch = merchandiseSubtotalExcludingGiftCents(cartSnapshot, handle);
    if (merch === null) merch = 0;

    var giftPresent = cartHasGiftLine(cartSnapshot, handle);
    var belowThreshold = merch < threshold;

    var cartJsUrl = getCartJsUrl();

    // Under threshold but gift line still in cart — wait for app to remove it, then reload.
    if (belowThreshold && giftPresent) {
      await pollCartUntil(cartJsUrl, function (cart) {
        return !cartHasGiftLine(cart, handle);
      }, maxMs, interval);
      hardReloadCartPage();
      return;
    }

    // Under threshold, no gift — OK to reload immediately.
    if (belowThreshold && !giftPresent) {
      hardReloadCartPage();
      return;
    }

    // At/above threshold, gift already in cart — OK to reload immediately.
    if (!belowThreshold && giftPresent) {
      hardReloadCartPage();
      return;
    }

    // At/above threshold, no gift yet — wait for app to add it, then reload.
    await pollCartUntil(cartJsUrl, function (cart) {
      return cartHasGiftLine(cart, handle);
    }, maxMs, interval);
    hardReloadCartPage();
  }

  window.themeCartPageReload = {
    hardReload: hardReloadCartPage,
    waitForGiftThenHardReload: waitForGiftThenHardReload
  };
})();
